import { createContext } from "react";

export const participantContext = createContext("");
